import gql from 'graphql-tag';

import dokkioUserDashboardFragment from '../fragments/dokkioUserDashboardFragment';

export const queryDokkioUserDashboard = gql`
  query dokkioUserDashboard {
    dokkioUserDashboard {
      ...dokkioUserDashboardFragment
    }
  }
  ${dokkioUserDashboardFragment}
`;
export default queryDokkioUserDashboard;
